import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { Modal } from '../../components/modal/Modal';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { useCalificacionesRecargas } from '../../../hooks/useCalificacionesRecargas';
import { EstrellaCalificacion } from '../../components/EstrellasCalificacion';
import { useModal } from '../../../hooks/useModal';

export const CalificacionRecargas =()=>{
    const {spinner,listarCalificaciones, calificaciones,listarCalificacionesDetalle,calificacionesDetalle} = useCalificacionesRecargas()
    const [isOpenModalCalificacion, openModalCalificacion, closeModalCalificacion] = useModal()
    const [usuarioElegido, setUsuarioElegido ] = useState({})
    const abrirModalCalificacion = () => {
        openModalCalificacion()
    }
    useEffect(() => {
        listarCalificaciones()
    }, []);
    return(
        <>
            <ContenedorParametros titulo="Calificación de recargas">
                <BotonProcesar onClick={()=> listarCalificaciones()}></BotonProcesar>
            </ContenedorParametros>
    
            <ContenedorTabla>
                <div className='containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-[30px]">N</th>
                                <th className="text-center">NOMBRE</th>
                                <th className="text-center">CALIFICACION PROMEDIO</th>
                                <th className="w-[10px]"></th>
                            </tr>
                        </thead>
                        <tbody>

                            {   
                                calificaciones?.length > 0 
                                ? calificaciones?.map((data, i) => {
                                    return (
                                        <tr key={i+1}>
                                            <td>{ i + 1}</td>
                                            <td className='text-center'>{data.uid}</td>
                                            <td className="text-center">
                                                <EstrellaCalificacion tamaño='xl' cantidadEstrellas= {data.promedioEstrella} ></EstrellaCalificacion>
                                            </td>
                                            <td className="text-center w-[10px]" >
                                                <button onClick={()=> {listarCalificacionesDetalle(data.uid);abrirModalCalificacion();setUsuarioElegido({usuario: data.nomUsuario,cantidadEstrellasPromedio:data.promedioEstrella})}} className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                                    <i className="fas fa-list"></i>
                                                </button>
                                            </td>    
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                    </tbody>
                    </table>
                </div>
            </ContenedorTabla>
    
            <Modal
                isOpen={isOpenModalCalificacion} closeModal={closeModalCalificacion} action={{}}
                title="Calificación de Operación"
                spinner={spinner}
                textButtons={{ confirm: '', denied: 'Cerrar' }}
                validButton={{confirm: false, denied: true}}
            >
                <div className="flex items-center  flex-wrap justify-center">
                    <div className="w-full text-xl ">
                        <div className='text-xl mb-3'>
                            <i className='text-xl fa fa-user pr-3' aria-hidden="true"></i>
                            {usuarioElegido.usuario}
                        </div>
                        <div>
                            Calificación promedio: <EstrellaCalificacion tamaño='' cantidadEstrellas={usuarioElegido.cantidadEstrellasPromedio}></EstrellaCalificacion>
                        </div>
                        <ContenedorTabla>
                            <div>Detalle de Calificaciones</div>
                            <div className='containerScroll  max-h-[300px] relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="w-[30px]">N</th>
                                            <th className="text-center">FECHA</th>
                                            <th>USUARIO</th>
                                            <th className="w-[10px]">ESTRELLAS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   
                                            calificacionesDetalle?.length > 0 
                                            ? calificacionesDetalle.map((detalle, i) => {
                                                return (
                                                    <tr key={i+1}>
                                                        <td>{i+1}</td>
                                                        <td className='text-center'>{ detalle.fechaCalificacion}</td>
                                                        <td className='text-center'>{ detalle.uid}</td>
                                                        <td className="text-center"><EstrellaCalificacion cantidadEstrellas= {detalle.cantidadEstrellas} ></EstrellaCalificacion></td>
                                                    </tr>
                                                )
                                            })
                                            : <tr><td colSpan="5" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </ContenedorTabla>
                    </div>
                </div>
            </Modal>
    
        </>
    )
}